module.exports = __webpack_public_path__ + "h5/img/Diane.ed745357.jpg";